import React from "react";

export default function AdhanDownload() {
  return (
    <div className="w-full md:h-lvh bg-[#D62C49] flex justify-center items-center">
      <div className="max-w-[1200px]">
        <div className="grid grid-cols-1 md:grid-cols-2 py-4 px-2 items-center">
          <div className="md:order-last">
            <p className="text-2xl font-bold text-white">
              Let's start your prayer tracking journey with Adhan.
            </p>
            <div className="pt-4 pb-4 flex items-center justify-center">
              <a href="https://apps.apple.com/us/app/adhan-prayer-timings/id6475295378">
                <img
                  src="/asset/adhan/logo/apple_logo_white.svg"
                  alt="Download on the App Store"
                />
              </a>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <img
              width={200}
              src="/asset/adhan/screen/adhan-1.webp"
              alt="Home Screenshot"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
